export default "__VITE_ASSET__DhfpQCPR__"